export default "__VITE_ASSET__DzpntGqY__"